import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import ProductosMedicos from "../views/ProductosMedicos.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/productos-medicos",
    name: "ProductosMedicos",
    component: ProductosMedicos,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
